import { useState } from "react";
import { Brush, Building2, CreditCard, History, IndianRupee, LayoutDashboard, LogOut, Menu, Send, ShieldCheck, UserMinus, UserRound, Users, Wallet, X } from "lucide-react";

const ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { key: "employer", label: "Employers", icon: Building2 },
  { key: "worker", label: "Employees", icon: UserRound },
  { key: "housekeeping", label: "Housekeeping", icon: Brush },
  { key: "payments", label: "Payments & Refunds", icon: CreditCard, owner: true },
  { key: "wallets", label: "Wallets", icon: Wallet, owner: true },
  { key: "exits", label: "Exit Requests", icon: UserMinus, owner: true },
  { key: "pricing", label: "Pricing", icon: IndianRupee, owner: true },
  { key: "telegram", label: "Telegram", icon: Send, owner: true },
  { key: "team", label: "Team", icon: Users, owner: true },
  { key: "activity", label: "Activity Log", icon: History, owner: true },
];

const NavList = ({ active, onSelect, isOwner, onLogout, badges = {} }) => (
  <nav className="flex flex-col gap-1 p-3">
    {ITEMS.filter((i) => !i.owner || isOwner).map(({ key, label, icon: Icon }) => (
      <button key={key} onClick={() => onSelect(key)} data-testid={`admin-nav-${key}`}
        className={`flex items-center gap-3 rounded-r-2xl px-4 py-3 text-left text-[15px] font-semibold transition-colors duration-150 ${active === key ? "bg-orange-600 text-white shadow-md" : "text-slate-200 hover:bg-white/10"}`}>
        <Icon className="h-5 w-5 shrink-0" />{label}
        {badges[key] > 0 && <span data-testid={`admin-nav-${key}-badge`} className="ml-auto min-w-[22px] rounded-full bg-red-500 px-1.5 py-0.5 text-center text-xs font-bold text-white">{badges[key] > 99 ? "99+" : badges[key]}</span>}
      </button>
    ))}
    <button onClick={onLogout} data-testid="admin-logout-button"
      className="mt-4 flex items-center gap-3 rounded-r-2xl px-4 py-3 text-left text-[15px] font-semibold text-red-300 hover:bg-red-500/20">
      <LogOut className="h-5 w-5" />Log out
    </button>
  </nav>
);

const Brand = ({ user }) => (
  <a href="/" data-testid="admin-home-link" className="flex items-center gap-3 border-b border-white/10 px-4 py-4">
    <span className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-orange-600 font-heading text-lg font-extrabold text-white shadow">
      B<ShieldCheck className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-red-500 p-0.5 text-white" />
    </span>
    <span className="min-w-0">
      <span className="block font-heading font-extrabold text-white">Admin Panel</span>
      <span data-testid="admin-user-email" className="block truncate text-xs text-slate-400">{user?.name || user?.email}</span>
    </span>
  </a>
);

export const AdminSidebar = (props) => {
  const [open, setOpen] = useState(false);
  const select = (k) => { setOpen(false); props.onSelect(k); };
  const nav = props;
  return (
    <>
      <aside data-testid="admin-sidebar" className="keep-dark fixed inset-y-0 left-0 z-40 hidden w-64 overflow-y-auto lg:block">
        <Brand user={props.user} />
        <NavList {...nav} />
      </aside>
      <div className="keep-dark sticky top-0 z-40 flex items-center justify-between px-3 lg:hidden">
        <Brand user={props.user} />
        <button onClick={() => setOpen(true)} data-testid="admin-sidebar-toggle" aria-label="Open menu" className="p-2 text-white"><Menu className="h-6 w-6" /></button>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 flex lg:hidden" data-testid="admin-sidebar-mobile">
          <div className="keep-dark w-72 overflow-y-auto shadow-xl">
            <div className="flex items-center justify-between pr-2"><Brand user={props.user} />
              <button onClick={() => setOpen(false)} data-testid="admin-sidebar-close" aria-label="Close menu" className="p-2 text-white"><X className="h-5 w-5" /></button>
            </div>
            <NavList {...nav} onSelect={select} />
          </div>
          <button className="flex-1 bg-black/50" aria-label="Close menu" onClick={() => setOpen(false)} />
        </div>
      )}
    </>
  );
};
